import reviews from "./reducer";

export default reviews;
